{
    "oversized": {
        "title": "Увага!",
        "body": "Зверніть увагу, що при онлайн розрахунках міжнародних збірних відправлень існують обмеження для країн, таких як Данія, Іспанія, Ірландія, Люксембург, Мальта, Німеччина, Норвегія, Португалія, Швейцарія, Швеція, Туреччина: максимальна загальна вага до 3000 кг, максимальна вага одиниці - 1500 кг; довжина до 2,4 метрів, ширина до 2,4 м і висота до 2,2 м. Для інших країн: загальна вага до 5000 кг, максимальна вага одиниці - 1500 кг; довжина до 4 метрів, ширина до 2,4 м і висота до 2,2 м. Для вантажів, що перевищують ці параметри, передбачена індивідуальна обробка."
    },
    "loadingWithTailLift": {
        "body": "Для вантажів, що перевозяться транспортними засобами з гідробортом, максимальна ширина становить 2 м, а максимальна вага - 750 кг. Для вантажів, які перевищують ці параметри, передбачена індивідуальна обробка."
    },
    "email": "Неправильно введена електронна пошта",
    "required": {
        "field": "Поле обов'язкове"
    },
    "minPassword": {
        "field": "Пароль має містити принаймні {{count}} символів"
    },
    "passwordsMustMatch": {
        "field": "Паролі мають збігатися"
    },
    "isPhoneNumber": {
        "field": "Недійсний номер телефону"
    },
    "passwordRequirements": {
        "field": "Пароль повинен містити принаймні одну цифру, одну малу та одну велику літеру"
    },
    "maxLength": {
        "field": "Довжина цього поля не повинна перевищувати {{count}} символів"
    },
    "minValue": {
        "field": "Значення має бути не менше {{min}}"
    }
}